module.exports = __webpack_public_path__ + "static/media/chevron-double-down.8f98ed71.svg";